app.service('serviceAvailability',function(console, modal, loading) {
	var $modal;
	function load(serviceCode){
		loading.start();
		$.ajax({
			data:{
				plu : serviceCode,
				zipCode : $('#services-zip-code').val(),
				currentUrl: document.location.href
			},
			url: '/serviceAvailability.ltr',
			success: function(data){
				loadSuccess(data);
			},
			complete:function(){
				loading.stop();
			}
		});
	}

	function loadSuccess(data){
		var modalId = 'modal-service-availability';

		modal.generate({
			id: modalId,
			content: data,
			cssClass: 'service-availability-modal',
			callbackOpen: function(){
				$modal = $('#'+modalId);

			}
		});
	}

	return {
		load:load
	};
});
